module.exports = __webpack_public_path__ + "static/media/003_A_transparent_chartoftheheavens.bfdf5b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/intel/003_A_transparent_chartoftheheavens.png
// module id = 473
// module chunks = 0